// IA-1/P3 (editar encuadre): arma el payload de `optimizarFoto` para un RE-ENCUADRE de una foto ya
// montada. Reutiliza la MISMA tubería que la optimización (sube JPG nuevo, reapunta en el mismo lugar,
// registra en FotoOptimizada para revertir), pero con origen 'encuadre' y conservando el alt. Puro.
import { normalizeFilename } from './productImages';

export function nombreArchivoEncuadre(nombre, variante = '') {
  const base = String(normalizeFilename(nombre, variante) || 'producto').replace(/\.(jpg|jpeg|webp|png)$/i, '');
  return `${base}-encuadre.jpg`;
}

// `imageBase64` = el JPG ya recortado (sin prefijo data:). `mediaId`/`src` = la foto VIEJA (se conserva
// para revertir). `alt` se conserva tal cual. `loteId` identifica este re-encuadre (para revertir).
export function payloadEncuadre({ imageBase64, nombre, variante = '', mediaId, src = '', alt = '', etiqueta = '', productId, loteId }) {
  return {
    imageBase64,
    imageMime: 'image/jpeg',
    filename: nombreArchivoEncuadre(nombre, variante),
    altText: alt,                                   // alt conservado
    viejoId: mediaId != null ? Number(mediaId) : null,
    viejoSrc: src || '',
    disparadoDesde: productId != null ? Number(productId) : null,
    loteId,
    etiqueta,
    origen: 'encuadre',
  };
}
